import { createSlice } from '@reduxjs/toolkit'
// import { OrganizationResponseTypes } from '../../../types/organization.type'

// general imports
import {
  ApiRequestDataType,
  ApiRequestStatus,
  StoredErrorResponseType,
} from '../../../types/api/api.types'
import {
  UnApprovedOrganisationsType,
  UnApprovedIndividualsType,
} from '../../../types/approve-request.type'
import { getApprovalRequestsThunk } from '../thunks/approval-request.thunks'

// import { OrganizationResponseTypes } from '../../../types/organisation.type'

export type approvalRequestsState = {
  // eslint-disable-next-line
  requestResponse: ApiRequestDataType<any>
  unApprovedOrganisations: UnApprovedOrganisationsType[]
  unApprovedIndividuals: UnApprovedIndividualsType[]
}

export const initialState: approvalRequestsState = {
  requestResponse: {
    status: ApiRequestStatus.IDLE,
    data: null,
  },
  unApprovedOrganisations: [] as UnApprovedOrganisationsType[],
  unApprovedIndividuals: [] as UnApprovedIndividualsType[],
}

const getApprovalRequestsSlice = createSlice({
  name: 'getApprovalRequestsSlice',
  initialState: initialState,
  reducers: {
    resetGetApprovalRequestsState: (state) => {
      ;(state.requestResponse.status = ApiRequestStatus.IDLE), (state.requestResponse.data = null)
      // (state.organizations = {} as OrganizationResponseTypes)
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getApprovalRequestsThunk.pending, (state) => {
        state.requestResponse.status = ApiRequestStatus.PENDING
        state.requestResponse.data = null
        state.requestResponse.error = {} as StoredErrorResponseType
      })
      .addCase(getApprovalRequestsThunk.fulfilled, (state, action) => {
        state.requestResponse.status = ApiRequestStatus.FULFILLED
        // Handle null or undefined payload gracefully
        state.unApprovedOrganisations = action.payload?.suspendedOrganisations?.content || []
        state.unApprovedIndividuals = action.payload?.inactiveUsers?.content || []
      })
      .addCase(getApprovalRequestsThunk.rejected, (state, action) => {
        state.requestResponse.status = ApiRequestStatus.REJECTED
        state.requestResponse.error = action.payload as StoredErrorResponseType
      })
  },
})

export const { resetGetApprovalRequestsState } = getApprovalRequestsSlice.actions
export default getApprovalRequestsSlice.reducer
